import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/missingPreview.jpg'


const _withScopeId = n => (_pushScopeId("data-v-451f5830"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-header-title is-block has-text-grey" }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "card-image" }
const _hoisted_8 = { class: "image" }
const _hoisted_9 = {
  key: 0,
  src: _imports_0
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "card-content" }
const _hoisted_12 = {
  key: 0,
  class: "has-text-centered"
}
const _hoisted_13 = { class: "text" }
const _hoisted_14 = {
  key: 1,
  class: "tags has-addons mb-0 is-justify-content-center"
}
const _hoisted_15 = { class: "tag is-warning" }
const _hoisted_16 = {
  key: 2,
  class: "has-text-centered"
}
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "metadata-content" }
const _hoisted_19 = {
  key: 3,
  class: "has-text-centered"
}
const _hoisted_20 = { class: "card-footer" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" View element ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ConfidenceTag = _resolveComponent("ConfidenceTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        (_ctx.document.parent_id !== null && _ctx.document.parent_id !== _ctx.document.element_id)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", {
                title: _ctx.document.parent_type,
                class: "mr-1"
              }, _toDisplayString(_ctx.truncateShort(_ctx.document.parent_type)), 9, _hoisted_4),
              _createVNode(_component_router_link, {
                to: { name: 'element-details', params: { id: _ctx.document.parent_id } },
                title: _ctx.document.parent_name
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.truncateLong(_ctx.document.parent_name)), 1)
                ]),
                _: 1
              }, 8, ["to", "title"]),
              _hoisted_5
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          title: _ctx.document.element_type,
          class: "mr-1"
        }, _toDisplayString(_ctx.truncateShort(_ctx.document.element_type)), 9, _hoisted_6),
        _createVNode(_component_router_link, {
          to: { name: 'element-details', params: { id: _ctx.document.element_id } },
          title: _ctx.document.element_text
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.truncateLong(_ctx.document.element_text)), 1)
          ]),
          _: 1
        }, 8, ["to", "title"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("figure", _hoisted_8, [
        (!_ctx.document.element_image || _ctx.imgFailed)
          ? (_openBlock(), _createElementBlock("img", _hoisted_9))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.document.element_image,
              onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imgFailed = true))
            }, null, 40, _hoisted_10))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.document.transcription_id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.truncated(_ctx.document.transcription_text)), 1),
            (Number.isFinite(_ctx.document.transcription_confidence))
              ? (_openBlock(), _createBlock(_component_ConfidenceTag, {
                  key: 0,
                  value: _ctx.document.transcription_confidence
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.classification_id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.document.classification_name), 1),
            (Number.isFinite(_ctx.document.classification_confidence))
              ? (_openBlock(), _createBlock(_component_ConfidenceTag, {
                  key: 0,
                  value: _ctx.document.classification_confidence
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.metadata_id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("span", {
              title: _ctx.document.metadata_type
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.iconClass(_ctx.document.metadata_type))
              }, null, 2)
            ], 8, _hoisted_17),
            _createElementVNode("span", _hoisted_18, [
              _createTextVNode(_toDisplayString(_ctx.document.metadata_name) + " : ", 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.document.metadata_text), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.entity_id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("span", null, _toDisplayString(_ctx.document.entity_text) + " (" + _toDisplayString(_ctx.document.entity_type) + ")", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_router_link, {
        class: "button is-white",
        to: { name: 'element-details', params: { id: _ctx.document.parent_id }, query: { highlight: _ctx.document.element_id } }
      }, {
        default: _withCtx(() => [
          _hoisted_21
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}